export default __webpack_public_path__ + "static/media/b4.a0d4990b.jpg";